<template>
  <router-view></router-view>
</template>

<script>
  import { obtenerReporteEnvio,getUser } from '@/util/util.js';
export default {
  data() {
      return {
          authenticated: false,
          mockAccount: {
              username: "prueba",
              password: "password"
          }
      }
  },
  methods: {
      setAuthenticated(status) {
          this.authenticated = status;
      },
      logout() {
          this.authenticated = false;
      }
  },
  created() {

      if(getUser()==null) {
          this.$router.replace({ name: "Login" });
      }

      obtenerReporteEnvio()
  }
}
</script>
